import React from 'react';

import { ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { config } from '../config.js';


export const LegendItems = ({nameAcc}) => {
  const {t} = useTranslation();

  return (
    <ListItem>
      <ListItemAvatar>
        <img src={config.url.PUBLIC_URL + `/layerIcons/${nameAcc}.png`} width="30px" height="30px" />
      </ListItemAvatar>
      <ListItemText  primary={t(`legend.${nameAcc}`)} disableTypography={true} />
    </ListItem>
  );
};